import { api } from './api';

// Define the API for managing parameters
export const paramApi = api.injectEndpoints({
  reducerPath: 'paramApi',
  tagTypes: ['Params'],
  endpoints: (builder) => ({
    // GET /api/administration/params
    getParams: builder.query({
      query: () => ({
        url: `/api/administration/params`,
        method: 'GET'
      }),
      providesTags: ['Params']
    }),
    // GET /api/administration/params/{code}
    getParamByCode: builder.query({
      query: (code) => ({
        url: `/api/administration/params/${code}`,
        method: 'GET'
      }),
      providesTags: ['Params']
    })
  })
});

// Export hooks for usage in functional components
export const { useGetParamsQuery, useGetParamByCodeQuery } = paramApi;
